import { render, staticRenderFns } from "./PatientsFilter.vue?vue&type=template&id=9902d5ee"
import script from "./PatientsFilter.vue?vue&type=script&lang=js"
export * from "./PatientsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports